export default {"src":"/_next/static/media/close.cae254e3.svg","height":513,"width":513};